import React, { useState, useEffect } from "react";
import DashboardHeader from "../components/Other/DashboardHeader";
import PageHeaderTitle from "../components/pages/PageHeaderTitle";
import { useTranslation } from "react-i18next";
import { chatList, clearNotification, deleteChat } from "../api/user/index";
import { useOutletContext } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Loader from "../components/Loader";
import { useSwipeable } from "react-swipeable";
import {
  faTrash,
  faImage,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { toast } from "react-toastify";

const ChatPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [categories, setCategories] = useState([]);
  const [activeTab, setActiveTab] = useState("ALL"); // Default active tab is 'ALL'
  const [isDataFeteched, setisDataFeteched] = useState(false);
  const [loader, setLoader] = useState(false);
  const [chatType, setChatType] = useState("ALL");

  const fetchChatList = async (type) => {
    // console.log(type, "type");
    let typeParam;
    switch (type) {
      case "ALL":
        typeParam = 1;
        break;
      case "FREE":
        typeParam = 2;
        break;
      case "PAID":
        typeParam = 3;
        break;
      default:
        console.error("Invalid chat type");
        return;
    }
    try {
      setLoader(true);
      const response = await chatList(typeParam);
      if (response) {
        const uniqueItems = response?.data?.data?.data.filter(
          (item) => item?.last_message?.id
        );
        const uniqueItems1 = uniqueItems.filter(
          (item) => item?.friend_details
          ?.id != 0
        );
        // console.log(uniqueItems, "uniqueItems");
        setCategories(uniqueItems1);
        setLoader(false);
        setisDataFeteched(true);
      }
    } catch (error) {
      setLoader(false);
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    notificationClear();
    if (!isDataFeteched) fetchChatList(activeTab); // Fetch chat list based on active tab when component mounts
  }, [activeTab, isDataFeteched]); // Fetch chat list whenever activeTab changes

  const handleTabClick = (type) => {
    setActiveTab(type);
    fetchChatList(type);
    setChatType(type);

    // Update active tab
  };
  const notificationClear = async () => {
    const data = 2;
    try {
      const response = await clearNotification(data);
      if (response) {
        // console.log(response);
        localStorage.setItem(
          "messageCount",
          response?.data?.data?.message_count
        );
        const notificationCount = localStorage.getItem("notificationCount");
        const myCustomEvent = new CustomEvent("myCustomEvent", {
          detail: {
            messageCount: response?.data?.data?.message_count,
            notificationCount: notificationCount,
          },
        });
        window.dispatchEvent(myCustomEvent);
      }
      // setLoading(false);
    } catch (error) {
      // setLoading(false);
      console.error("Error:", error);
    }
  };
  const handleclick = (chat) => {
    // console.log(chat, "aaaaaaaaaaaa");
    localStorage.setItem("id", chat.friend_details.id);
    localStorage.setItem("gid", chat.id);
    localStorage.setItem("image", chat.friend_details.image); // Storing the image URL
    navigate(`/chatHistory/${chat?.friend_details?.id}/${chat?.id}`);
  };

  function calculateTimeAgo(created_at) {
    const currentDate = new Date();
    const createdAtDate = new Date(created_at);

    // Ensure time difference is non-negative
    const timeDifference = Math.max(
      0,
      currentDate.getTime() - createdAtDate.getTime()
    );

    const secondsInMs = 1000;
    const minutesInMs = secondsInMs * 60;
    const hoursInMs = minutesInMs * 60;
    const daysInMs = hoursInMs * 24;
    const monthsInMs = daysInMs * 30; // Note: Approximation, as months have varying numbers of days
    const yearsInMs = daysInMs * 365; // Note: Does not account for leap years

    if (timeDifference < secondsInMs) {
      return "just now";
    } else if (timeDifference < minutesInMs) {
      return Math.round(timeDifference / secondsInMs) + "s ago";
    } else if (timeDifference < hoursInMs) {
      return Math.round(timeDifference / minutesInMs) + "m ago";
    } else if (timeDifference < daysInMs) {
      return Math.round(timeDifference / hoursInMs) + "h ago";
    } else if (timeDifference < monthsInMs) {
      return Math.round(timeDifference / daysInMs) + "d ago";
    } else if (timeDifference < yearsInMs) {
      // Change 'm' to 'mo' to avoid confusion with 'minutes'
      return Math.round(timeDifference / monthsInMs) + "mo ago";
    } else {
      return Math.round(timeDifference / yearsInMs) + "y ago";
    }
  }

  const [sidebarToggle] = useOutletContext();

  const SwipeableChatItem = ({ chat, onRemove }) => {
    const [style, setStyle] = useState({ left: 0 });
    const [swipeAction, setSwipeAction] = useState(""); // 'delete' or 'archive'

    const handlers = useSwipeable({
      onSwiping: (eventData) => {
        const deltaX = eventData.deltaX;
        // Allow swiping to both left and right
        if (deltaX < 0) {
          // Swiping to the left
          setStyle({ left: Math.max(deltaX, -100) }); // Replace 100 with your threshold
          setSwipeAction("delete");
        }
        // else {
        //   // Swiping to the right
        //   setStyle({ left: Math.min(deltaX, 100) }); // Replace 100 with your threshold
        //   setSwipeAction("archive");
        // }
      },
      onSwiped: async (eventData) => {
        if (eventData.deltaX < -50 && swipeAction === "delete") {
          // Replace 50 with your delete threshold
          try {
            setLoader(true);
            const response = await deleteChat(
              chat?.last_message?.chat_group_id
            );
            if (response && response?.data) {
              setLoader(false);
              toast.success(response.data.message);
              fetchChatList(chatType);
            }
          } catch (error) {
            console.error("Error deleting chat:", error);
            toast.error(error.response.data.message);
            setLoader(false);
          }
        }
        // else if (eventData.deltaX > 50 && swipeAction === "archive") {
        //   // Replace 50 with your archive threshold
        //   console.log("Archive action for chat:", chat);
        // }
        // Reset swipe action and style after the swipe is complete
        setSwipeAction("");
        setStyle({ left: 0 });
      },
      preventDefaultTouchmoveEvent: true,
      trackMouse: true,
    });

    const isMobileView = document.body.clientWidth <= 768;

    return (
      <div className="relative overflow-hidden">
        {/* <div
          className={`absolute inset-y-0 left-0 flex items-center bg-[#71AB59] pl-4 ${
            swipeAction === "archive" ? "w-24" : "w-0"
          }`}
        >
          <FontAwesomeIcon
            className="text-white ml-4 text-lg"
            icon={faArchive}
          />
        </div> */}
        {/* Background for Delete (Swipe Left) */}
        <div
          className={`absolute inset-y-0 right-0 flex items-center bg-red-500  ${swipeAction === "delete" ? "w-24" : "w-0"
            }`}
        >
          <FontAwesomeIcon className="text-white ml-8 text-lg" icon={faTrash} />
        </div>
        <div
          {...handlers}
          className="relative cursor-pointer bg-white"
          style={style}
        >
          <div
            onClick={() =>
              chat.friend_details.user_name !== "deleted_user" &&
              handleclick(chat)
            }
            key={chat.id}
          >
            <div className="flex flex-col">
              <div className="tab-content">
                <div className="flex flex-col">
                  <div className="flex items-center p-4 bg-white rounded-lg shadow">
                    <div className="relative mr-3 flex-shrink-0">
                      <img
                        src={chat.friend_details.image}
                        alt="User Name"
                        className="object-cover w-12 h-12 rounded-full"
                      />
                      <span className="absolute bottom-0 right-0 block h-3 w-3 bg-green-500 border-2 border-white rounded-full"></span>
                    </div>
                    <div className="flex-grow">
                      <div className="flex justify-between">
                        <span className="font-semibold">
                          {chat.friend_details.user_name}
                        </span>
                        <span className="text-sm text-gray-500">
                          {calculateTimeAgo(chat.last_message.created_at)}
                        </span>
                      </div>
                      <div className="flex justify-between items-center">
                        <p className="text-gray-500 truncate">
                          {" "}
                          {chat.last_message ? (
                            <>
                              {chat.last_message &&
                                chat.last_message.message ? (
                                isMobileView ? (
                                  <span className="block text-sm text-gray-500">
                                    {chat.last_message.message.length > 75
                                      ? `${chat.last_message.message.substring(
                                        0,
                                        20
                                      )}...`
                                      : chat.last_message.message}
                                  </span>
                                ) : (
                                  <span className="block text-sm text-gray-500">
                                    {chat.last_message.message.length > 75
                                      ? `${chat.last_message.message.substring(
                                        0,
                                        60
                                      )}...`
                                      : chat.last_message.message}
                                  </span>
                                )
                              ) : (
                                ""
                              )}
                              {chat.last_message.attachments &&
                                chat.last_message.attachments.length > 0 && (
                                  <span className="block text-sm text-gray-500">
                                    <FontAwesomeIcon
                                      className="ml-2"
                                      icon={faImage}
                                    />
                                    <span className="ml-2">Image</span>
                                  </span>
                                )}
                            </>
                          ) : (
                            <span className="block text-sm text-gray-500">
                              No messages
                            </span>
                          )}
                        </p>
                        {chat.message_count > 0 && (
                          <span className="count bg-primaryColor text-white text-xs font-bold rounded-full w-[21px] h-[21px] px-2 py-0.5 ml-1">
                            {chat.message_count}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  return (
    <>
      <DashboardHeader toggle={sidebarToggle} />
      <PageHeaderTitle title={t("Chat History")} />

      <div className="bg-white">
        <main className="h-full bg-white pt-4 md:ml-72 ml-0">
          <div className="flex justify-center">
            <button
              onClick={() => handleTabClick("ALL")}
              className={`px-3 sm:px-4 py-2 rounded-md focus:outline-none ${activeTab === "ALL"
                  ? "bg-primaryColor text-white"
                  : "text-gray-500 hover:bg-gray-100"
                }`}
            >
              ALL
            </button>
            <button
              onClick={() => handleTabClick("FREE")}
              className={`px-3 sm:px-4 py-2 rounded-md focus:outline-none ${activeTab === "FREE"
                  ? "bg-primaryColor text-white"
                  : "text-gray-500 hover:bg-gray-100"
                }`}
            >
              FREE
            </button>
            <button
              onClick={() => handleTabClick("PAID")}
              className={`px-3 sm:px-4 py-2 rounded-md focus:outline-none ${activeTab === "PAID"
                  ? "bg-primaryColor text-white"
                  : "text-gray-500 hover:bg-gray-100"
                }`}
            >
              PAID
            </button>
          </div>
          <div className="w-full mt-3 h-px bg-gray-300"></div>{" "}
          {/* Full width line separator */}
          <div className="md:block  rounded-2xl bg-white max-w-[60rem] mx-auto">
            <div>
              {!loader && categories && categories.length > 0 ? (
                categories.map((chat) => (
                  <SwipeableChatItem key={chat.id} chat={chat} />
                ))
              ) : loader ? (
                <Loader />
              ) : (
                <div className="text-center font-bold text-black py-4 px-4 mt-3 mb-4">
                  <p>No chat available</p>
                </div>
              )}
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default ChatPage;
